import { useState } from "react";
import { Collapse } from "react-bootstrap";
import { Link } from "@tanstack/react-router";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { ChangeOrgModal } from "../../modules/admin/ChangeOrgModal";
import SidebarLink from "./SidebarLink";
import { GoWorkflow } from "react-icons/go";
import { GrScorecard } from "react-icons/gr";
import { FaTicketAlt, FaBug } from "react-icons/fa";
import { BugReportModal } from "../BugReport";

const StaffSidebar = ({ activeSection }) => {
  const { t } = useTranslation(["common"]);
  const [openStaff, setOpenStaff] = useState(false);

  const isActive = (routeName) => {
    return document.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  const activeLinkStyles = {
    borderBottom: "1px solid #2e0054",
    borderRadius: 0,
  };

  return (
    <li
      className="user w-100"
      style={{
        marginBottom: "2rem",
        marginTop: 0,
        paddingBottom: 0,
        borderBottom: "none",
      }}
    >
      <a
        href="#"
        className="active"
        onClick={(e) => {
          e.preventDefault();
          setOpenStaff(!openStaff);
        }}
        style={{
          backgroundColor: activeSection === "staff" ? "#2e0054" : "inherit",
        }}
      >
        <i
          className="pe-7s-keypad"
          style={{
            color: activeSection === "staff" ? "#FFF" : "#2e0054",
          }}
        ></i>
        <p
          className="w-100"
          style={{
            color: activeSection === "staff" ? "#FFF" : "#2e0054",
            width: "100%",
          }}
        >
          {t(($) => $.common.sidebar["Staff Tools"])}
          <span className={`caret ${openStaff && `rotate-180`}  dropdown-toggle`} />
        </p>
      </a>
      <Collapse in={openStaff}>
        <ul className="nav">
          <SidebarLink
            small
            to={"/user/staff/dashboard"}
            isActive={isActive("/user/staff/dashboard")}
            icon={<i className="fa fa-list" />}
          >
            {t(($) => $.common.sidebar["All Customers"])}
          </SidebarLink>
          <li className="w-100">
            <a
              role="button"
              tabIndex={0}
              onClick={() => NiceModal.show(ChangeOrgModal)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  NiceModal.show(ChangeOrgModal);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <span className="sidebar-mini ps-1">
                <i className="fa fa-group" />
              </span>
              <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar["Switch Profiles"])}</span>
            </a>
          </li>
          <li className={`w-100 ${isActive("/user/applications")}`}>
            <Link
              to="/user/applications"
              activeProps={{}}
              style={isActive("/user/applications") ? activeLinkStyles : {}}
            >
              <span className="sidebar-mini ps-1">
                <i className="fa fa-key" />
              </span>
              <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar["Manage Applications"])}</span>
            </Link>
          </li>
          <li className={`w-100 ${isActive("/user/staff/workflows")}`}>
            <Link
              to="/user/staff/workflows"
              activeProps={{}}
              style={isActive("/user/staff/workflows") ? activeLinkStyles : {}}
            >
              <span className="sidebar-mini" style={{ fontSize: "17px" }}>
                <GoWorkflow />
              </span>
              <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar.Workflows)}</span>
            </Link>
          </li>
          <li className={`w-100 ${isActive("/user/staff/reportcard")}`}>
            <Link
              to="/user/staff/reportcard"
              activeProps={{}}
              style={isActive("/user/staff/reportcard") ? activeLinkStyles : {}}
            >
              <span className="sidebar-mini" style={{ fontSize: "17px" }}>
                <GrScorecard />
              </span>
              <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar["Report Card"])}</span>
            </Link>
          </li>
          <li className={`w-100`}>
            <Link to="/user/tickets" activeProps={{}}>
              <span className="sidebar-mini" style={{ fontSize: "17px" }}>
                <FaTicketAlt />
              </span>
              <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar.Tickets)}</span>
            </Link>
          </li>
          <li className={`w-100 ${isActive("/user/tclip/transcripts")}`}>
            <Link
              to="/user/tclip/transcripts"
              activeProps={{}}
              style={isActive("/user/tclip/transcripts") ? activeLinkStyles : {}}
            >
              <span className="sidebar-mini ps-2">
                <i className="fa fa-key" />
              </span>
              <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar.Transcripts)}</span>
            </Link>
          </li>
          <li className="w-100">
            <a
              role="button"
              tabIndex={0}
              onClick={() => NiceModal.show(BugReportModal)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  NiceModal.show(BugReportModal);
                }
              }}
              style={{ cursor: "pointer" }}
            >
              <span className="sidebar-mini" style={{ fontSize: "17px" }}>
                <FaBug />
              </span>
              <span className="sidebar-normal sidebar-link">{t(($) => $.common.sidebar["Report a Bug"])}</span>
            </a>
          </li>
        </ul>
      </Collapse>
    </li>
  );
};

export default StaffSidebar;
